/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Fullname1Inputs */

const zh_auth_fullname1 = /** @type {(inputs: Auth_Fullname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`姓名`)
};

const en_auth_fullname1 = /** @type {(inputs: Auth_Fullname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Full Name`)
};

const es_auth_fullname1 = /** @type {(inputs: Auth_Fullname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nombre completo`)
};

/**
* | output |
* | --- |
* | "Full Name" |
*
* @param {Auth_Fullname1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const auth_fullname1 = /** @type {((inputs?: Auth_Fullname1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Fullname1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_auth_fullname1(inputs)
	if (locale === "en") return en_auth_fullname1(inputs)
	return es_auth_fullname1(inputs)
});
export { auth_fullname1 as "auth_fullName" }